import React from 'react';
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import ContentLoader from "react-content-loader"
import _ from 'lodash';
import {fetchForumLastTopics, resetForumLastTopics} from "../../../creators/forum.last.topics";
import Advertising from "../../components/Advertising/Advertising";
import CardLastTopics from "./components/CardLastTopics";
import Title from "../../components/Title";
import {Link} from "react-router-dom";
import createLink from "../../../libs/createLink";
import {config} from "../../../config";
import Helmet from "react-helmet";



class ForumLastTopics extends React.Component {
    constructor(props) {
        super(props);

        this.fetchForumLastTopics();
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }


    componentWillUnmount() {
        this.props.resetForumLastTopics();
    }

    fetchForumLastTopics() {
        this.props.fetchForumLastTopics()
    }


    render() {

        return (
            <div id="forums">
                <Helmet>
                    <title>{config.preTitle}Derniers messages{config.postTitle}</title>
                    <meta name="robots" content="noindex" />
                </Helmet>
                <div className="container">
                    <div className={"forum-card"}>
                        <div className={"card"}>
                            <div className={`topline row`}>
                                <Title className={"title-wrapper"} heading={"heading-1"} display={"display-0"}>
                                    <Link to={"/"}>
                                        Accueil
                                    </Link>
                                </Title>
                                <span style={{"padding" : "4px 8px", "fontSize": "14px", "fontWeight": "bold"}}> > </span>
                                <Title className={"title-wrapper"} heading={"heading-1"} display={"display-0"}>
                                    <Link to={createLink("forum")}>
                                        Forum Sexe
                                    </Link>
                                </Title>

                                <span style={{"padding" : "4px 8px", "fontSize": "14px", "fontWeight": "bold"}}> > </span>

                                <Title className={"title-wrapper"} heading={"heading-2"} display={"display-0"}>
                                    <Link to={`${createLink("forumLastTopics")}`}>
                                        Derniers messages
                                    </Link>
                                </Title>
                            </div>
                            <div className="forums-subcategory">
                                <div className="container">
                                    <Advertising sizeMobile={"300x100"} className={"center"} />
                                    <div className={"forum-card"}>
                                        <div className={"card big mt-0"}>
                                            {!this.props.forumTopicsInitialized ? (
                                            <div className="p-16">
                                                {_.times(10).map((item, index) => (
                                                    <ContentLoader
                                                        key={index}
                                                        height={38}
                                                        width={800}
                                                        speed={2}
                                                        ariaLabel={false}
                                                        primaryColor="#f3f3f3"
                                                        secondaryColor="#ecebeb"
                                                    >
                                                        <circle cx="22.5" cy="18.29" r="16.5"/>
                                                        <rect x="50.56" y="18.61" rx="4" ry="4" width="161" height="5"/>
                                                        <rect x="504.56" y="13.61" rx="4" ry="4" width="65" height="5"/>
                                                        <rect x="497.56" y="23.61" rx="4" ry="4" width="73" height="5"/>
                                                        <circle cx="597.35" cy="19.4" r="13.79"/>
                                                        <rect x="665.56" y="6.61" rx="4" ry="4" width="124" height="5"/>
                                                        <rect x="667.56" y="17.61" rx="4" ry="4" width="122" height="5"/>
                                                        <rect x="665.56" y="28.61" rx="4" ry="4" width="125" height="5"/>
                                                    </ContentLoader>
                                                ))}
                                            </div>
                                            ) : (
                                            this.props.forumTopics.map((topic, topicIndex) => (
                                                    <CardLastTopics
                                                        {...topic}
                                                        currentUser={this.props.currentUser}
                                                        key={topicIndex}
                                                        match={this.props.match}
                                                    />
                                                ))
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

const mapStateToProps = (state) => {

    return {
        currentUser: state.currentUser.data,
        currentUserInitialized: state.currentUser.initialized,


        forumTopics: state.forumLastTopics.data,
        forumTopicsLoading: state.forumLastTopics.loading,
        forumTopicsInitialized: state.forumLastTopics.initialized,
        forumTopicsTotal: state.forumLastTopics.total,

    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchForumLastTopics,
    resetForumLastTopics
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ForumLastTopics);
